<footer>
  <app-opin-button
    *ngFor="let button of buttons"
    [variant]="button.type"
    [text]="button.text"
    [disabled]="!!button.disabled"
    (onClick)="button.onClick()"
  ></app-opin-button>
</footer>
